export default __webpack_public_path__ + "ef72124ec1aaaa1e768580332070518b.pdf";